import { render, staticRenderFns } from "./EditEntityModal.vue?vue&type=template&id=2b9eb98b"
import script from "./EditEntityModal.vue?vue&type=script&lang=js"
export * from "./EditEntityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports